import React, { useState, useEffect } from 'react';

import { Carousel } from 'primereact/carousel';
import { Galleria } from 'primereact/galleria';
import { ProductService } from '../service/ProductService';

const MessagesDemo = (props) => {

    const [value,setValue] = useState('');


    const [products, setProducts] = useState([]);

    const responsiveOptions = [
        {
            breakpoint: '991px',
            numVisible: 4
        },
        {
            breakpoint: '767px',
            numVisible: 3
        },
        {
            breakpoint: '575px',
            numVisible: 1
        }
    ];

    const itemTemplate = (item) => {
        return <img src={"https://www.atakent2.org.tr"+item.link} alt={item.description} style={{ width: '100%', display: 'block' }} />;
    }

    const thumbnailTemplate = (item) => {
        return <img src={item.thumbnailImageSrc} alt={item.alt} style={{ display: 'block', }} />;
    }

    const carouselItemTemplate = (product) => {
        return (
            <div className="product-item">
                <div className="product-item-content">
                    <div className="mb-3">
                        {/*<img src={`assets/demo/images/product/${product.image}`} alt={product.name} className="product-image" />*/}
                        <img src={"https://www.atakent2.org.tr"+product.link} alt={product.description} className="product-image" />
                    </div>
                    
                </div>
            </div>
        );
    };

    useEffect(() => {
        console.log(props.data);
        
        const productService = new ProductService();
        //productService.getProducts().then((products) => setProducts(products));
        setProducts(props.data.galeri)
    }, []);

   
    return (
        <div >
            <div className="grid p-fluid media-demo " style={{justifyContent:'center'}}>
                
                
                    <div className="card">
                    <h5 style={{marginLeft:510}}>Galeri</h5>
                        {/*<Carousel value={products} numVisible={1} numScroll={1} itemTemplate={carouselItemTemplate} ></Carousel>*/}
                        
                        <Galleria value={products} numVisible={5} circular style={{ maxWidth: '100%' }} 
                showItemNavigators showItemNavigatorsOnHover showIndicators 
                showThumbnails={false} item={itemTemplate} thumbnail={thumbnailTemplate} />
         
                    </div>
                </div>
            
        </div>
    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(MessagesDemo, comparisonFn);
